"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incomeOptionTypes = void 0;
exports.incomeOptionTypes = [
    '20000-50000',
    '50000-100000',
    '100000-150000',
    '150000-240000'
];
